export const initialUnitCodesState = {
  unitCodes: []
};

export interface IUnitCodesState {
  unitCodes: any[]
}
